export const appName = "authentication"
